import { bookingAssets } from '../../constants/assets'
import type { RecentBooking } from '../../types'
import { formatPassengers, formatRecentBookingDate } from '../../utils/format'
import { MoneyLabel } from '../ui/MoneyLabel'
import { StatusPill } from '../ui/StatusPill'

type RecentBookingItemProps = {
  booking: RecentBooking
}

export const RecentBookingItem = ({ booking }: RecentBookingItemProps) => (
  <article className="flex h-[94px] items-center justify-between gap-[8px] rounded-[11px] border border-solid border-white bg-white px-[8px] shadow-dash-booking">
    <div className="flex min-w-0 items-center gap-[6px]">
      <div className="relative h-[76px] w-[68px] shrink-0 overflow-hidden rounded-[4.8px]">
        <img
          alt=""
          aria-hidden
          className="absolute left-[calc(50%-20px)] top-[-6px] h-[82px] w-[146px] max-w-none -translate-x-1/2 object-cover"
          src={booking.thumbnail}
        />
      </div>

      <div className="flex min-w-0 flex-col items-start gap-[5px]">
        <p className="font-host text-[16px] font-normal leading-[1.3] text-black">{booking.title}</p>

        <div className="flex items-start gap-[8px]">
          <span className="flex items-center gap-[4px]">
            <img alt="" aria-hidden className="block size-[14px] max-w-none object-cover" src={bookingAssets.calendar} />
            <span className="whitespace-nowrap font-poppins text-[12px] leading-[1.3] tracking-[-0.36px] text-black">
              {formatRecentBookingDate(booking.date)}
            </span>
          </span>

          <span className="flex items-center gap-[4px]">
            <img alt="" aria-hidden className="block size-[4px] max-w-none" src={bookingAssets.separatorDot} />
            <span className="whitespace-nowrap font-host text-[12px] font-normal leading-[18px] text-black">
              {formatPassengers(booking.guests)}
            </span>
          </span>
        </div>

        <StatusPill status={booking.status} size="sm" />
      </div>
    </div>

    <div className="flex w-[48px] shrink-0 flex-col items-start gap-[45px]">
      <p className="flex h-[11px] items-center font-host font-medium text-dash-link">
        <span className="text-[12px] leading-[10px]">sc-</span>
        <span className="text-[10px] leading-[10px]">{booking.reference}</span>
      </p>
      <MoneyLabel amount={booking.amount} />
    </div>
  </article>
)
